// extracted by mini-css-extract-plugin
export default {"container":"radio_container__f+Wyt","label":"radio_label__SgXQk","input":"radio_input__bkHUa"};